import { string } from '@amcharts/amcharts4/core';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'ara-exact-location',
  templateUrl: './exact-location.component.html',
  styleUrls: ['./exact-location.component.css']
})
export class ExactLocationComponent implements OnChanges {
  @Input()
  IsRequired: boolean=false;
  @Input()
  Location: string;
  @Input()
  Disabled: boolean = false;
  @Output()
  Output: EventEmitter<any>;
  subscription: any;
  SelectLocationDialog : boolean = false;

  constructor(private baseService: BaseService) {
    this.Output = new EventEmitter();
    
  }

  ngOnChanges() {
     
      this.Output.emit(this.Location);
     
  }

  addressChange(address: any) {
    this.Output.emit(`Lat ${address.geometry.location.lat()}, Long ${address.geometry.location.lng()}`);
  }

  getLocation() {
   // this.getDefaultLocation();
    this.SelectLocationDialog=true;
    if(this.Location && this.Location != "" && this.Location != null)
    {
      this.getLatitudeLongitude(this.Location);
      this.latitude=Number(this.latitude);
      this.longitude=Number(this.longitude);
    }
    else
    {
    this.subscription = this.baseService.getLocation().subscribe(position => {
    this.latitude=position.coords.latitude;
    this.longitude=position.coords.longitude;
      // this.Output.emit(this.createPosition(position));
      // this.subscription.unsubscribe();
    });
    }
  }
  createPosition() {
    //return 'Lat ' + position.coords.latitude + ", Long " + position.coords.longitude;
    
    return 'Lat ' + this.latitude.toString().substring(0, 8)  + ", Long " + this.longitude.toString().substring(0, 8);
     
  }
  getDefaultLocation() {
    this.subscription = this.baseService.getLocation().subscribe(position=> {
      this.Output.emit(this.createDefaultPosition(position));
    });
  }
  createDefaultPosition(position) {
    return 'Lat ' + position.coords.latitude + ", Long " + position.coords.longitude;
  }
  ngOnDestroy() {
    this.Location = '';
    this.Disabled = false;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  latitude :any;
  longitude :any;
  locationChosen=true;
  onChoseLocation(event:any)
  {
this.latitude=event.coords.lat;
this.longitude=event.coords.lng;
this.locationChosen=true;
  }

  closePopUp() {
    this.SelectLocationDialog = false;
   
  }
  SelectLocation()
  {
    var lat:string=this.latitude;
    console.log( lat.toString().substring(0, 25));
    console.log( this.longitude);
      // this.Output.emit(this.createPosition(  'Lat ' + this.latitude + ", Long " + this.longitude));
      //  this.subscription.unsubscribe();
      this.Output.emit(this.createPosition());
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
       this.SelectLocationDialog  = false;
  }
  getLatitudeLongitude(location)
  { 
    if (location.includes('/') || location.includes(','))
    {
      let data : any = [];
      data = location.includes('/') ? location.split('/') : location.includes(',') ? location.split(',') : [];
      data.forEach(d =>
      { 
       if (d.toLowerCase().includes("lat"))
       {
        this.latitude = d.trim().includes('-') ? d.trim().split('-')[1].trim() : d.trim().includes(':') ? d.trim().split(':')[1].trim() : d.trim().split(' ')[1].trim();
       }
       if (d.toLowerCase().includes("long") || d.toLowerCase().includes("lng"))
       {
         this.longitude = d.trim().includes('-') ? d.trim().split('-')[1].trim() : d.trim().includes(':') ? d.trim().split(':')[1].trim() : d.trim().split(' ')[1].trim();
       }
       });
     }
  }
}
